/** @jsxImportSource @emotion/react */
import AccessIcon from '@app/assets/icons/AccessIcon'
import AccordionArrowDownIcon from '@app/assets/icons/AccordionArrowDownIcon'
import AccordionArrowUpIcon from '@app/assets/icons/AccordionArrowUpIcon'
import ArrowLeftRightIcon from '@app/assets/icons/ArrowLeftRightIcon'
import AssetAreaIcon from '@app/assets/icons/AssetAreaIcon'
import BuildingIcon from '@app/assets/icons/BuildingIcon'
import BulbIcon from '@app/assets/icons/BulbIcon'
import ChartLineUpIcon from '@app/assets/icons/ChartLineUpIcon'
import CloudWithLightningBoltIcon from '@app/assets/icons/CloudWithLightningBoltIcon'
import CO2CloudIcon from '@app/assets/icons/CO2CloudIcon'
import CopyIcon from '@app/assets/icons/CopyIcon'
import CorporationIcon from '@app/assets/icons/Corporation'
import DragIcon from '@app/assets/icons/DragIcon'
import DrawCancelIcon from '@app/assets/icons/DrawCancelIcon'
import DrawPolyIcon from '@app/assets/icons/DrawPolyIcon'
import DrawRectangleIcon from '@app/assets/icons/DrawRectangleIcon'
import DrawRulerIcon from '@app/assets/icons/DrawRulerIcon'
import EarthOceaniaIcon from '@app/assets/icons/EarthOceaniaIcon'
import EditIcon from '@mui/icons-material/ModeEdit'
import GuideIcon from '@app/assets/icons/GuideIcon'
import ForumIcon from '@app/assets/icons/ForumIcon'
import HorizonScanIcon from '@app/assets/icons/HorizonScanIcon'
import HorticultureIcon from '@app/assets/icons/Horticulture'
import InfoIcon from '@app/assets/icons/InfoIcon'
import LandIcon from '@app/assets/icons/LandIcon'
import LayersIcon from '@app/assets/icons/LayersIcon'
import LeafIcon from '@app/assets/icons/LeafIcon'
import LifeLineIcon from '@app/assets/icons/LifeLineIcon'
import LineIcon from '@app/assets/icons/LineIcon'
import LogisticsIcon from '@app/assets/icons/Logistics'
import MaraeIcon from '@app/assets/icons/MaraeIcon'
import MonitorIcon from '@app/assets/icons/MonitorIcon'
import NewZealandIcon from '@app/assets/icons/NewZealandIcon'
import PackhouseIcon from '@app/assets/icons/PackhouseIcon'
import PaperPageIcon from '@app/assets/icons/PaperPageIcon'
import PeopleIcon from '@app/assets/icons/PeopleIcon'
import PetrolIcon from '@app/assets/icons/PetrolIcon'
import PillIcon from '@app/assets/icons/PillIcon'
import PinIcon from '@app/assets/icons/PinIcon'
import { PrioritisationIcon } from '@app/assets/icons/PrioritisationIcon'
import ProteinsIcon from '@app/assets/icons/Proteins'
import { RexIcon } from '@app/assets/icons/RexIcon'
import { RiskIcon } from '@app/assets/icons/RiskIcon'
import RoadIcon from '@app/assets/icons/RoadIcon'
import SchoolIcon from '@app/assets/icons/SchoolIcon'
import SettingsIcon from '@app/assets/icons/SettingsIcon'
import SnowFlakeIcon from '@app/assets/icons/SnowFlakeIcon'
import SummaryIcon from '@app/assets/icons/SummaryIcon'
import TooltipIcon from '@app/assets/icons/TooltipIcon'
import TreeIcon from '@app/assets/icons/TreeIcon'
import WarningIcon from '@app/assets/icons/WarningIcon'
import WindIcon from '@app/assets/icons/WindIcon'
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import CloseIcon from '@mui/icons-material/Close'
import DeleteIcon from '@mui/icons-material/Delete'
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk'
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import KeyIcon from '@mui/icons-material/Key'
import LiveHelpIcon from '@mui/icons-material/LiveHelp'
import LoginIcon from '@mui/icons-material/Login'
import LogoutIcon from '@mui/icons-material/Logout'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import NotificationsIcon from '@mui/icons-material/Notifications'
import NotInterestedIcon from '@mui/icons-material/NotInterested'
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera'
import PodcastsIcon from '@mui/icons-material/Podcasts'
import RefreshIcon from '@mui/icons-material/Refresh'
import ReportIcon from '@mui/icons-material/Report'
import ReportOutlinedIcon from '@mui/icons-material/ReportOutlined'
import SaveIcon from '@mui/icons-material/Save'
import SearchIcon from '@mui/icons-material/Search'
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes'
import SpeakerNotesOffIcon from '@mui/icons-material/SpeakerNotesOff'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import { HomeIcon } from '@app/assets/icons/HomeIcon'
import { memo } from 'react'
import { IconEmbedded } from '../IconEmbedded'
import { iconContainer } from './Icon.styles'
import PropertyIcon from '@app/assets/icons/PropertyIcon'
import ShadCNIcon from '@app/assets/icons/ShadCNIcon'
import { RexLiveIcon } from '@app/assets/icons/RexLiveIcon'

const PUBLIC_ASSETS_BASE_URL = import.meta.env.VITE_PUBLIC_ASSETS_BASE_URL
  ? import.meta.env.VITE_PUBLIC_ASSETS_BASE_URL
  : 'https://d2ufl17mx4sema.cloudfront.net/public'

export const iconGlyphs = [
  'AccordionArrowDown',
  'AccordionArrowUp',
  'ArrowLeftRight',
  'AssetArea',
  'Building',
  'Bulb',
  'Camera',
  'ChartLineUp',
  'ChevronDown',
  'ChevronLeft',
  'ChevronRight',
  'ChevronUp',
  'Close',
  'CloudWithLightningBolt',
  'CO2Cloud',
  'Copy',
  'Corporation',
  'Delete',
  'DirectionsWalk',
  'Drag',
  'DrawCancel',
  'DrawPoly',
  'DrawRectangle',
  'DrawRuler',
  'EarthOceania',
  'EditIcon',
  'EyeHidden',
  'EyeVisible',
  'EmojiTransportation',
  'Forum',
  'Help',
  'Home',
  'HorizonScan',
  'Horticulture',
  'Info',
  'Key',
  'Land',
  'Layers',
  'Leaf',
  'LifeLine',
  'Line',
  'Logistics',
  'Marae',
  'Monitor',
  'More',
  'NotificationsIcon',
  'NotInterested',
  'NewZealand',
  'Packhouse',
  'PaperPage',
  'People',
  'Petrol',
  'Pill',
  'Pin',
  'Proteins',
  'Podcasts',
  'Refresh',
  'ReportIcon',
  'ReportOutlinedIcon',
  'Road',
  'SaveIcon',
  'School',
  'Search',
  'Settings',
  'SignIn',
  'SignOut',
  'SnowFlake',
  'Spanner',
  'SpeakerNotes',
  'SpeakerNotesOff',
  'Tooltip',
  'Tree',
  'VerifiedUserIcon',
  'Warning',
  'Wind',
] as const
export type Icon = (typeof iconGlyphs)[number] | string

export type IconSize = 'small' | 'medium' | 'large' | 'fit' /* 16 | 20 | 24 | 100% */

export interface IconProps {
  iconName?: Icon
  colour?: string
  fillColour?: string
  size?: IconSize
  onClick?: () => void
  src?: string
  alt?: string
  className?: string
  active?: boolean
}

export const IconComp = ({
  iconName,
  size = 'medium',
  colour = '#5C5C5C',
  fillColour = undefined,
  src,
  alt = 'Icon',
  onClick,
  className,
  active = false,
}: IconProps) => {
  const iconProps = {
    css: iconContainer({ colour, size, fillColour }),
    onClick,
    className,
  }

  if (iconName && looksLikeUrl(iconName)) {
    return <IconEmbedded colour={colour} src={generateS3Url(iconName)} alt={alt} {...iconProps} />
  }

  if (src) {
    return <IconEmbedded colour={colour} src={src} alt={alt} {...iconProps} />
  }

  switch (iconName) {
    case 'AccordionArrowDown':
      return <AccordionArrowDownIcon {...iconProps} />
    case 'AccordionArrowUp':
      return <AccordionArrowUpIcon {...iconProps} />
    case 'ArrowLeftRight':
      return <ArrowLeftRightIcon {...iconProps} />
    case 'AssetArea':
      return <AssetAreaIcon {...iconProps} />
    case 'Building':
      return <BuildingIcon {...iconProps} />
    case 'Bulb':
      return <BulbIcon {...iconProps} />
    case 'Camera':
      return <PhotoCameraIcon {...iconProps} />
    case 'ChartLineUp':
      return <ChartLineUpIcon {...iconProps} />
    case 'Close':
      return <CloseIcon {...iconProps} />
    case 'CloudWithLightningBolt':
      return <CloudWithLightningBoltIcon {...iconProps} />
    case 'ChevronDown':
      return <ExpandMoreIcon {...iconProps} />
    case 'ChevronUp':
      return <ExpandLessIcon {...iconProps} />
    case 'ChevronLeft':
      return <ChevronLeftIcon {...iconProps} />
    case 'ChevronRight':
      return <ChevronRightIcon {...iconProps} />
    case 'CO2Cloud':
      return <CO2CloudIcon {...iconProps} />
    case 'Copy':
      return <CopyIcon {...iconProps} />
    case 'Corporation':
      return <CorporationIcon {...iconProps} />
    case 'Delete':
      return <DeleteIcon {...iconProps} />
    case 'DirectionsWalk':
      return <DirectionsWalkIcon {...iconProps} />
    case 'Drag':
      return <DragIcon {...iconProps} />
    case 'DrawCancel':
      return <DrawCancelIcon {...iconProps} />
    case 'DrawPoly':
      return <DrawPolyIcon {...iconProps} />
    case 'DrawRectangle':
      return <DrawRectangleIcon {...iconProps} />
    case 'DrawRuler':
      return <DrawRulerIcon {...iconProps} />
    case 'EarthOceania':
      return <EarthOceaniaIcon {...iconProps} />
    case 'EditIcon':
      return <EditIcon {...iconProps} />
    case 'EyeHidden':
      return <VisibilityOffIcon {...iconProps} />
    case 'EyeVisible':
      return <VisibilityIcon {...iconProps} />
    case 'EmojiTransportation':
      return <EmojiTransportationIcon {...iconProps} />
    case 'Help':
      return <LiveHelpIcon {...iconProps} />
    case 'Home':
      return <HomeIcon {...iconProps} active={active} />
    case 'HorizonScan':
      return <HorizonScanIcon {...iconProps} />
    case 'Horticulture':
      return <HorticultureIcon {...iconProps} />
    case 'Info':
      return <InfoIcon {...iconProps} />
    case 'Key':
      return <KeyIcon {...iconProps} />
    case 'Land':
      return <LandIcon {...iconProps} />
    case 'Layers':
      return <LayersIcon {...iconProps} />
    case 'Leaf':
      return <LeafIcon {...iconProps} />
    case 'LifeLine':
      return <LifeLineIcon {...iconProps} />
    case 'Line':
      return <LineIcon {...iconProps} />
    case 'Logistics':
      return <LogisticsIcon {...iconProps} />
    case 'Marae':
      return <MaraeIcon {...iconProps} />
    case 'Monitor':
      return <MonitorIcon {...iconProps} />
    case 'More':
      return <MoreHorizIcon {...iconProps} />
    case 'NotificationsIcon':
      return <NotificationsIcon {...iconProps} />
    case 'NotInterested':
      return <NotInterestedIcon {...iconProps} />
    case 'NewZealand':
      return <NewZealandIcon {...iconProps} />
    case 'Packhouse':
      return <PackhouseIcon {...iconProps} />
    case 'PaperPage':
      return <PaperPageIcon {...iconProps} />
    case 'People':
      return <PeopleIcon {...iconProps} />
    case 'Petrol':
      return <PetrolIcon {...iconProps} />
    case 'Pill':
      return <PillIcon {...iconProps} />
    case 'Pin':
      return <PinIcon {...iconProps} />
    case 'Proteins':
      return <ProteinsIcon {...iconProps} />
    case 'Podcasts':
      return <PodcastsIcon {...iconProps} />
    case 'Refresh':
      return <RefreshIcon {...iconProps} />
    case 'Report':
      return <ReportIcon {...iconProps} />
    case 'Report-Outlined':
      return <ReportOutlinedIcon {...iconProps} />
    case 'Road':
      return <RoadIcon {...iconProps} />
    case 'SaveIcon':
      return <SaveIcon {...iconProps} />
    case 'School':
      return <SchoolIcon {...iconProps} />
    case 'Search':
      return <SearchIcon {...iconProps} />
    case 'Settings':
      return <SettingsIcon {...iconProps} />
    case 'SignIn':
      return <LoginIcon {...iconProps} />
    case 'SignOut':
      return <LogoutIcon {...iconProps} />
    case 'SnowFlake':
      return <SnowFlakeIcon {...iconProps} />
    case 'Spanner':
      return <BuildOutlinedIcon {...iconProps} />
    case 'SpeakerNotes':
      return <SpeakerNotesIcon {...iconProps} />
    case 'SpeakerNotesOff':
      return <SpeakerNotesOffIcon {...iconProps} />
    case 'Tooltip':
      return <TooltipIcon {...iconProps} />
    case 'Tree':
      return <TreeIcon {...iconProps} />
    case 'VerifiedUserIcon':
      return <VerifiedUserIcon {...iconProps} />
    case 'Warning':
      return <WarningIcon {...iconProps} />
    case 'Wind':
      return <WindIcon {...iconProps} />
    case 'RexIcon':
      return <RexIcon {...iconProps} active={active} />
    case 'GuideIcon':
      return <GuideIcon {...iconProps} active={active} />
    case 'RiskIcon':
      return <RiskIcon {...iconProps} active={active} />
    case 'AccessIcon':
      return <AccessIcon {...iconProps} active={active} />
    case 'SummaryIcon':
      return <SummaryIcon {...iconProps} active={active} />
    case 'PrioritisationIcon':
      return <PrioritisationIcon {...iconProps} active={active} />
    case 'PropertyIcon':
      return <PropertyIcon {...iconProps} active={active} />
    case 'ForumIcon':
      return <ForumIcon {...iconProps} active={active} />
    case 'ShadCNIcon':
      return <ShadCNIcon {...iconProps} active={active} />
    case 'RexLiveIcon':
      return <RexLiveIcon {...iconProps} active={active} />

    default:
      return <HomeIcon {...iconProps} active={active} />
  }
}

export const Icon = memo(IconComp, (prevProps, nextProps) => {
  return (
    prevProps.iconName === nextProps.iconName &&
    prevProps.size === nextProps.size &&
    prevProps.colour === nextProps.colour &&
    prevProps.fillColour === nextProps.fillColour &&
    prevProps.src === nextProps.src &&
    prevProps.alt === nextProps.alt &&
    prevProps.className === nextProps.className &&
    prevProps.onClick === nextProps.onClick
  )
})

function generateS3Url(src: string) {
  const lowerCaseSrc = src.toLocaleLowerCase()

  if (lowerCaseSrc.startsWith('s3://')) {
    const iconIdS3 = lowerCaseSrc.replace('s3://', '')
    // if icon doesn't end with a dot and an extension, add .svg
    if (!iconIdS3.includes('.')) {
      return `${PUBLIC_ASSETS_BASE_URL}/icons/${iconIdS3}.svg`
    }
    return `${PUBLIC_ASSETS_BASE_URL}/icons/${iconIdS3}`
  }

  return src
}

function looksLikeUrl(iconId: string) {
  // Could start with 'http://' or 's3://'
  return iconId.indexOf('://') >= 0
}
